var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowReload1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10H11.875V13.125",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86408 9.37303C3.21451 10.2404 3.80123 10.992 4.55755 11.5425C5.31387 12.093 6.20945 12.4203 7.14251 12.4872C8.07558 12.5541 9.00869 12.3579 9.83579 11.9209C10.6629 11.4839 11.3508 10.8236 11.8214 10.0151",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5H3.125V1.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.136 5.62697C11.7856 4.75963 11.1989 4.00799 10.4425 3.45748C9.68622 2.90698 8.79063 2.57968 7.85757 2.5128C6.92451 2.44592 5.9914 2.64213 5.16429 3.07913C4.33719 3.51614 3.64926 4.17641 3.17871 4.9849",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReload1);
export default __webpack_public_path__ + "static/media/ArrowReload1.c955527b81bd0dc103a2392c1402bc48.svg";
export { ForwardRef as ReactComponent };